import { render, staticRenderFns } from "./complianceResult.vue?vue&type=template&id=b0f7e08c"
import script from "./complianceResult.vue?vue&type=script&lang=js"
export * from "./complianceResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b0f7e08c')) {
      api.createRecord('b0f7e08c', component.options)
    } else {
      api.reload('b0f7e08c', component.options)
    }
    module.hot.accept("./complianceResult.vue?vue&type=template&id=b0f7e08c", function () {
      api.rerender('b0f7e08c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/pca/result/complianceResult.vue"
export default component.exports